<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-top">
        <div class="footer-info">
          <h3 class="footer-title">Гайдук Янина Сергеевна</h3>
          <p class="footer-subtitle">Учитель математики высшей категории</p>
          <div class="footer-contacts">
            <p>г. Краснодар</p>
            <p>Email: y.gaiduk@yandex.ru</p>
          </div>
        </div>

        <div class="sphere-wrapper">
          <div class="sphere">
            <div class="sphere-frame"></div>
          </div>
        </div>

        <nav class="footer-nav">
          <ul class="footer-menu">
            <li v-for="(item, index) in navItems" :key="index">
              <router-link :to="item.link" class="footer-link">
                {{ item.title }}
              </router-link>
            </li>
          </ul>
        </nav>
      </div>

      <div class="footer-bottom">
        <p class="footer-copyright">
          © 2025 учитель-математики.рф | Гайдук Янина Сергеевна
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MainFooter',
  data() {
    return {
      navItems: [
        { title: 'Главная', link: '/' },
        { title: 'О себе', link: '/about' },
        { title: 'Материалы', link: '/materials' },
        { title: 'Связь со мной', link: '/contact' }
      ]
    }
  }
}
</script>

<style scoped>
.footer {
  background: #ffffff;
  padding: 80px 20px 60px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.03);
}

.footer-container {
  max-width: 1280px;
  margin: 0 auto;
  position: relative;
}

.footer-top {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  justify-items: center;
  gap: 40px;
  padding-bottom: 60px;
  margin-bottom: 40px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.footer-info {
  text-align: center;
  padding: 0 20px;
  justify-self: end;
}

.footer-nav {
  padding: 0 20px;
  justify-self: start;
}

.sphere-wrapper {
  position: relative;
  padding: 30px;
  perspective: 1000px;
}

.sphere {
  width: 240px;
  height: 240px;
  position: relative;
  transform-style: preserve-3d;
  animation: rotate-3d 25s linear infinite;
}

.sphere-frame {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid rgba(100, 150, 255, 0.6);
  transform-style: preserve-3d;
}

.sphere-frame::before,
.sphere-frame::after,
.sphere-frame div {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 1px solid rgba(100, 150, 255, 0.3);
  left: 0;
  top: 0;
  transform-style: preserve-3d;
}

.sphere-frame::before {
  transform: rotateX(60deg) rotateY(30deg);
  box-shadow: 0 0 15px rgba(100, 150, 255, 0.2);
}

.sphere-frame::after {
  transform: rotateX(-45deg) rotateY(-60deg);
  border-width: 2px;
}

.sphere-frame div:nth-child(1) {
  transform: rotateZ(45deg) rotateX(30deg);
  border-color: rgba(100, 150, 255, 0.4);
}

.sphere-frame div:nth-child(2) {
  transform: rotateZ(-30deg) rotateY(60deg);
  border-color: rgba(100, 150, 255, 0.25);
}

.sphere-frame div:nth-child(3) {
  transform: rotateX(75deg) rotateZ(15deg);
  border-color: rgba(100, 150, 255, 0.2);
}

@keyframes rotate-3d {
  0% { transform: rotateX(0) rotateY(0) rotateZ(0); }
  100% { transform: rotateX(720deg) rotateY(360deg) rotateZ(180deg); }
}

.footer-title {
  font-size: 28px;
  color: #2c3e50;
  margin-bottom: 15px;
  font-weight: 700;
  line-height: 1.2;
}

.footer-subtitle {
  color: #666;
  font-size: 18px;
  margin-bottom: 25px;
  line-height: 1.4;
}

.footer-contacts {
  color: #777;
  line-height: 1.6;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-contacts p {
  margin: 10px 0;
}

.footer-menu {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
}

.footer-link {
  color: #444;
  text-decoration: none;
  font-weight: 500;
  position: relative;
  padding: 8px 0;
  transition: all 0.3s ease;
  display: inline-block;
}

.footer-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: rgba(100, 150, 255, 0.8);
  transition: width 0.3s ease;
}

.footer-link:hover {
  color: rgba(100, 150, 255, 0.9);
  transform: translateX(5px);
}

.footer-link:hover::after {
  width: 100%;
}

.footer-bottom {
  text-align: center;
  padding-top: 40px;
}

.footer-copyright {
  color: #666;
  font-size: 14px;
  margin: 0;
  line-height: 1.6;
}

@media (max-width: 1200px) {
  .footer-top {
    gap: 30px;
  }

  .footer-info {
    justify-self: center;
    text-align: center;
  }

  .footer-nav {
    justify-self: center;
    text-align: center;
  }
}

@media (max-width: 992px) {
  .footer-top {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .footer-info,
  .footer-nav {
    justify-self: center;
    text-align: center;
    padding: 0;
  }

  .sphere-wrapper {
    order: 0;
    padding: 40px 0;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 60px 20px 100px;
  }

  .sphere {
    width: 200px;
    height: 200px;
  }

  .footer-title {
    font-size: 24px;
  }
}

@media (max-width: 576px) {
  .footer {
    padding: 50px 15px 80px;
  }

  .sphere {
    width: 180px;
    height: 180px;
  }

  .footer-subtitle {
    font-size: 16px;
  }

  .footer-copyright {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .sphere {
    width: 160px;
    height: 160px;
  }

  .sphere-wrapper {
    padding: 30px 0 50px;
  }
}
</style>